Em.Handlebars.helper 'toPercent', (value, format) ->
  value * 100